import { isProd } from './app-utils';

/**
 * @description Filters CMS content fragments to match a specific (More...)
 * @param items cms items returned from CSM API
 * @param fragmentId string  Identifies a specific content fragment
 * @param eventType
 * @returns
 */
export const getContentFragment = (
  items: any[],
  fragmentId: string,
  eventType?: string
): any => {
  const matchFragment = eventType ? `${fragmentId}-${eventType}` : fragmentId;
  return (items || []).find((item) => item?._path.includes(matchFragment));
};

/* eslint-disable no-shadow */
export enum FragmentIdentifier {
  teamInvite = 'team-invite',
  joinTeam = 'join-team',
  createTeam = 'create-team',
  eventDetails = 'eventdetails',
}
export const getFullImagePath = (cmsPath: string): string =>
  `https://www${!isProd ? `.qa` : ``}.stjude.org${cmsPath}`;
